var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / subway 32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-subway-32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "abb_train_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Drive",
    transform: "translate(3.000000, 3.000000)",
    fill: "#1F1F1F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,19.12 L25.07,18.05 C26.1997843,16.9219214 26.2481337,15.1066188 25.18,13.92 L18.34,6.32 C17.5884462,5.48721566 16.5217371,5.00828506 15.4,5 L9,5 L10,4 L7,1 L12,1 L12,0 L0,0 L0,1 L4,1 L7,4 L6,5 L0,5 L0,7 L15.4,7 C15.9643565,7.00133393 16.5018817,7.24104112 16.88,7.66 L18.09,9 L12,9 C10.8954305,9 10,9.8954305 10,11 L10,12 C10,13.1045695 10.8954305,14 12,14 L22.59,14 L23.72,15.26 C24.0819426,15.64495 24.0819426,16.24505 23.72,16.63 L22.65,17.71 C22.4612812,17.8971865 22.205803,18.0015368 21.94,18 L0,18 L0,20 L21.9,20 C22.6884432,19.9940272 23.4428401,19.6778989 24,19.12 L24,19.12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 23,
    width: 26,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,22.93 C13.6745549,22.9279606 14.7006939,22.1357813 15,21 L10,21 C10.2993061,22.1357813 11.3254451,22.9279606 12.5,22.93 L12.5,22.93 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,22.93 C6.67455492,22.9279606 7.70069389,22.1357813 8,21 L3,21 C3.29930611,22.1357813 4.32544508,22.9279606 5.5,22.93 L5.5,22.93 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubway);
export default __webpack_public_path__ + "static/media/subway.be75b236993723086f36b052fcc26227.svg";
export { ForwardRef as ReactComponent };